// extracted by mini-css-extract-plugin
export var cardLayout = "_8f-1";
export var paginationContainer = "_8f-0";